export default __webpack_public_path__ + "static/SRUS RT80 - Product Specifications & Technical Data-d02b20d1803400e1de6f0973856a64d8.pdf";